module.exports = __webpack_public_path__ + "static/media/MGM_Mobile.4a73a8a0.png";